import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../models';

interface FormatAddressOptions {
  singleLine?: boolean;
}

@Pipe({ name: 'formatAddress' })
export class FormatAddressPipe implements PipeTransform {
  transform(address?: Address, options: FormatAddressOptions = { singleLine: false }): string {
    if (!address) return '';

    let formattedAddress = '';

    if (address.line1) {
      formattedAddress = address.line1;
    }

    if (address.line2) {
      if (formattedAddress) {
        formattedAddress += options.singleLine ? `, ${address.line2}` : `<br/>${address.line2}`;
      } else {
        formattedAddress = address.line2;
      }
    }

    if (address.attention) {
      if (formattedAddress) {
        formattedAddress += options.singleLine ? `, ATTN: ${address.attention}` : `<br/>ATTN: ${address.attention}`;
      } else {
        formattedAddress = `ATTN: ${address.attention}`;
      }
    }

    let cityStateZip = '';

    if (address.city || address.state || address.zipCode) {
      if (address.city) {
        cityStateZip = address.city;
      }

      if (address.state) {
        if (cityStateZip) {
          cityStateZip += `, ${address.state}`;
        } else {
          cityStateZip = address.state;
        }
      }

      if (address.zipCode) {
        if (cityStateZip) {
          cityStateZip += address.state ? ` ${address.zipCode}` : `, ${address.zipCode}`;
        } else {
          cityStateZip = address.zipCode;
        }
      }
    }

    if (cityStateZip) {
      formattedAddress += options.singleLine ? `, ${cityStateZip}` : `<br/>${cityStateZip}`;
    }

    return formattedAddress;
  }
}
